import * as THREE from 'three';
import { Base3DPart } from "./base-part";

export class CoverBack3DPart extends Base3DPart {
    override load(scene: THREE.Scene): void {
      const objPath = `${this.basePath}/cover-back.gltf`;
  
      this.gltfLoader.load(objPath, (gltf) => {
        scene.add(gltf.scene);
      });
    }
  }